<template>
  <div style="background-color:#f5f5f5">
    <div class="cont" style="padding-top:29px;padding-bottom:20px">
      <div style="color:#999999;margin-bottom:26px">支付订单</div>
      <div style="background-color:#fff;padding:55px 64px;box-sizing:border-box;display:flex;align-items:center">
        <!-- <i class="el-icon-check" style="color:#00c29d;font-size:40px;margin-right:30px"></i>
        <div style="flex:1">
          <div style="font-size: 24px;color: #666666;margin-bottom:9px">订单提交成功！请尽快完成支付。</div>
          <div style="color: #999999 ">请在  <span style="color:#f90000">2小时0分</span>  内完成支付, 超时后将取消订单</div>
        </div> -->
        <div>
          <span style="font-size: 14px;color: #666666;">应付总额：</span>
          <span style="font-size: 20px;font-weight: 700;color: #D10217;">￥{{ obj.payPrice ? obj.payPrice : 0 }}</span>
        </div>
      </div>

      <div style="padding: 0 57px">
        <div style="margin:30px 0">支付方式</div>
        <div style="margin-top:30px;display:flex;border:1px solid #e4e4e4;padding:30px 34px;align-items:center" class="radio_cont">
           <el-radio-group v-model="radio1" @change='radioChange1' style="display: flex;align-items:center">
            <el-radio  label="1" border class="el_radio_item el_radio_item_wx" > {{ ' ' }}</el-radio>
            <el-radio  label="2" border class="el_radio_item el_radio_item_zfb" >{{ ' ' }} </el-radio>
            <el-radio  label="4" border class="el_radio_item" v-if="showJiaohang">银行转账</el-radio>
            <!--<div style="font-size: 12px;color: #7F7F7F;">
              <div>交行收款开放时间: 工作日9:00-18:00 周末10:00-18:00</div>
              <div>国定假日请咨询客服</div>
            </div>-->
           </el-radio-group>

        </div>
      </div>


      <div style="padding: 0 57px">
        <div style="margin:30px 0">发票信息</div>
        <div style="margin-top:30px;margin-bottom:74px;display:flex;border:1px solid #e4e4e4;padding:30px 34px;align-items:center">
          <el-checkbox
            v-model="checked1"
            label="我需要开发票"
            border
            style="width:227px;text-align:center;height:50px;line-height:28px;" @change="changeInvoice"></el-checkbox>
            <div style="margin-left:20px;color:#f90000;font-weight:700;font-size:14px">重要提示：需开具公司抬头增值税专用发票，仅支持与开票抬头相同的单位银行账户进行付款。</div>
        </div>
      </div>


      <div style="text-align:center;margin-bottom:109px">
        <!-- <el-button type="success" style="width:200px;background-color:#00ca59">立即支付</el-button> -->
        <div
          class="background_style btn"
          :style="{backgroundImage: 'url(' + btn_red + ')' }"
          style="display:inline-block;width:290px;height:63px;line-height:63px;font-size: 20px;cursor : pointer"
          @click="createOrder"
        >
          立即支付
        </div>
      </div>

      <el-dialog title="发票信息" :visible.sync="dialogFormVisible" :before-close="handleClose" width="600px" center>
        <div style="display:flex;margin-bottom:20px" class="radio_cont">
          <el-radio-group v-model="radio2" @change='radioChange2' style="display: flex;">
            <el-radio  label="0" border style="width:259px;height:40px;line-height:16px;text-align:center" class="el_radio_item" >增值税普通发票 </el-radio>
            <el-radio  label="1" border style="width:259px;height:40px;line-height:16px;text-align:center" class="el_radio_item" >增值税专用发票</el-radio>
          </el-radio-group>

        </div>

        <el-form :model="form" class="clear">
          <el-form-item label="收票人姓名" style="float:left;width:255px;;margin-right:40px">
            <!-- <el-input v-model="userAddress.name" ></el-input> -->
            {{ userAddress.name }}
          </el-form-item>
          <el-form-item label="收票人手机" style="float:left;width:255px;">
            <!-- <el-input v-model="userAddress.phone" ></el-input> -->
            {{ userAddress.phone }}
          </el-form-item>
          <el-form-item label="收票人地址" style="float:left;width:100%">
            <!-- <el-input v-model="userAddress.address"  ></el-input> -->
            {{ userAddress.address }}
          </el-form-item>
        </el-form>

        <div style="color:#999999 ; font-size: 12px;">
          <div style="margin-bottom:7px">发票须知：</div>
          <div style="margin-bottom:7px">1. 修改税号等发票信息请联系客服；</div>
          <div style="margin-bottom:7px">2. 选择发票的订单付款后纳税人识别号不可修改，请确认信息后付款；</div>
          <div style="margin-bottom:7px">3. 发票金额为实际支付金额，不包含优惠券。</div>
        </div>

        <div slot="footer" class="dialog-footer">
          <div
            @click="dialogFormVisibleCancel"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            style="display:inline-block;margin-right:50px;cursor : pointer"
          >
            取 消
          </div>
          <div
            @click="addressChangeClick"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            style="display:inline-block;margin-right:50px;cursor : pointer"
          >
            切换地址
          </div>
          <div
            @click="dialogFormVisible = false"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="display:inline-block;cursor : pointer"
          >
            确 定
          </div>
        </div>
      </el-dialog>

      <el-dialog class="pub_dialog" title="选择收货地址" :visible.sync="addressChangeVisible" width="700" center>
        <div style="box-sizing:border-box;height:40px;display:flex">
          <el-input placeholder="请输入内容" v-model="input2" class="input-with-select" style="flex:1;height:100%" clearable>
            <el-button slot="append" >搜索</el-button>
          </el-input>
        </div>

        <div style="height:350px;margin-top:20px;overflow-y:auto">
          <div
            class="addresslist_item"
            :class="{ 'addresslist_item_active': itemName.isSelected }"
            v-for="(itemName,i) in addressList"
            :key="i"
            style="cursor : pointer"
            @click="addresslist_item_click(i)"
          >
            <div style="display:flex;line-height:30px;">
              <div style="width:100px">收货人 :</div>
              <div style="color:#666666">{{ itemName.name }}</div>
            </div>

            <div style="display:flex;line-height:30px">
              <div style="width:100px">联系方式 : </div>
              <div style="color:#666666">{{ itemName.phone }} </div>
            </div>

            <div style="display:flex;line-height:30px">
              <div style="width:100px">收货地址 : </div>
              <div style="color:#666666;flex:1">{{itemName.provName + itemName.cityName+ itemName.distName +itemName.detail }}</div>
              <div v-show=' itemName.isDefault == 1 ' style="color:#f90000">
                默认地址
              </div>
            </div>
          </div>

        </div>

        <div slot="footer" class="dialog-footer">
          <div
            @click="addressChangeVisible = false"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            style="display:inline-block;margin-right:50px;cursor : pointer"
          >
            取 消
          </div>
          <div
            @click="selectAddress"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="display:inline-block;cursor : pointer"
          >
            确 定
          </div>
        </div>
      </el-dialog>

      <el-dialog title="支付" :visible.sync="payVisible" width="600px" center
        :show-close='false'
        :close-on-press-escape='false'
        :close-on-click-modal	='false'
      >
        <div style="margin-bottom:10px">
          商户名称 : {{ payObj.company}}
        </div>
        <div style="margin-bottom:10px">
          订单编号 : {{ payObj.orderNo}}
        </div>
        <div style="margin-bottom:10px">
          支付方式 : {{ payObj.payChannel == 1 ? '微信' : ''}}{{ payObj.payChannel == 2 ? '支付宝' : ''}}{{ payObj.payChannel == 4 ? '银行转账' : ''}}
        </div>
        <div style="margin-bottom:10px">
          支付价格 : ¥{{ payObj.price}}
        </div>
        <div style="margin-bottom:5px">
          {{ timeLeft }}
        </div>

        <div style="width:100%;;margin-bottom:10px;display:flex;">
          <el-image
            style="width: 300px; "
            :src=' "data:image/jpeg;base64," + payObj.code_image '
            fit="contain"
          ></el-image>
          <el-image
            style="width: 300px; margin-left:10px"
            :src=' weixinPhone '
            fit="contain"
            v-if="payObj.payChannel == 1"
          ></el-image>
          <el-image
            style="width: 300px; margin-left:10px"
            :src=' zfbPhone '
            fit="contain"
            v-else-if="payObj.payChannel == 2"
          ></el-image>
        </div>
        <div style="display:flex;justify-content:center">
          <div
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            @click="payCancel"
            style="cursor : pointer"
          >
            取消支付
          </div>
        </div>

      </el-dialog>

    </div>
  </div>

</template>




<script>
  import {  getUserAddressListReq  , getDefaultUserAddressReq} from '@/api/userAddress/index' //
  import {  presalePayOrderReq , payStatusReq , verifyKeyReq } from '@/api/orderPay/index'
  export default {
    data() {
      return {
        timeLeft : '' , //支付剩余时间
        radio1 : '1' ,
        radio2 : "0" ,
        input2 : '' ,
        user_invoiceType : '1' ,
        checked1 : false ,
        dialogFormVisible : false ,
        addressChangeVisible : false , //地址显示
        payVisible : false ,  //支付弹框
        form: {
          name: '',
        },
        btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
        btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
        weixinPhone :  require('@/assets/image/order/orderPay/weixinphone.png') ,
        zfbPhone :  require('@/assets/image/order/orderPay/zfbphone.png') ,

        obj : '' ,
        userAddress : {
          name : '' ,
          phone : '' ,
          address : '' ,
        } ,
        userDefaultAddress : {} ,
        type : 0 ,
        addressList : [] ,

        code_image : '' , //支付图片
        payObj : {
          code_image : '' ,
          company : '' ,
          orderNo : '' ,
          payChannel : '' ,
          price : '' ,
        } , //支付数据
        showJiaohang : true ,

      };
    },
    computed: {
      moduleUser() {
        return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
      }
    },

    methods: {
      verifyKey(){
        verifyKeyReq({
          verifyKey : this.obj.verifyKey
        }).then(res => {
          // console.log( res )
          if( res.data.status == 1){
            this.$confirm('', '该订单已存在,请至我的订单查看', {
              confirmButtonText: '确定',
              type: 'warning',
              showClose : false ,
              showCancelButton : false ,
              closeOnClickModal : false ,
              closeOnPressEscape : false ,
              closeOnHashChange : false ,
              center : true
            }).then(() => {
              this.$router.replace({
                path: '/user/order' ,
              })
            })
          }
        })
      },
      //切换支付方式
      radioChange1(){
        this.checked1 = false
        this.radio2 = '0'
      },
      //是否开具发票
      radioChange2(e){
        // console.log( e )
        // 判断
        if( this.radio1 == 1 ){
          this.$message({
            message: '使用个人微信支付的，只能开具增值税普票' ,
            type: 'warning'
          });
          this.radio2 = '0'
          return
        }else if(  this.radio1 == 2 ){
          this.$message({
            message: '使用个人支付宝支付的，只能开具增值税普票' ,
            type: 'warning'
          });
          this.radio2 = '0'
          return
        }

        if(this.user_invoiceType!=3){
          this.$message({
            message: '您注册时未提交增值税专票资料，请联系相关客服，补录开票信息' ,
            type: 'error'
          });
          this.radio2 = '0'
          return;
        }
      },
      changeInvoice(val){
        if(this.user_invoiceType==1){
          this.$message({
            message: '您注册时未提交开票资料，请联系相关客服，补录开票信息' ,
            type: 'error'
          });
          this.checked1 =false;
          return;
        }
        if( val ){
          this.dialogFormVisible = true
        }
      },
      handleClose(){
        this.dialogFormVisible = false
      },
      getDefaultUserAddress(){
        getDefaultUserAddressReq({
          type : 0
        }).then( res => {
          if (res.data.status == 0) {
            this.user_invoiceType =res.data.invoiceType;
            res.data.userAddress.address = res.data.userAddress.provName + res.data.userAddress.cityName + res.data.userAddress.distName + res.data.userAddress.detail
            this.userDefaultAddress = res.data.userAddress
            this.userAddress = this.userAddress.name ? this.userAddress : res.data.userAddress
          }else{
            this.$message({
              message: res.data.statusDesc ,
              type: 'warning'
            });
          }
        })
      },
      //取消发票信息
      dialogFormVisibleCancel(){
        this.dialogFormVisible = false
        this.checked1 = false
        this.radio2 = '1'
      },
      //切换地址
      addressChangeClick(){
        this.addressChangeVisible = true
        getUserAddressListReq({
          type : this.type
        }).then(res=>{
          if (res.data.status == 0) {
            let list = res.data.list
            list.forEach( ( val  )=> {
              val.isSelected = false
            })
            this.addressList = list

          }else{
            this.$message.error(res.data.statusDesc);
          }
        })
      } ,
      //切换地址选中项
      addresslist_item_click( i ){
        // console.log( i )
        this.addressList.forEach( ( item , itx ) => {
          if( itx == i ){
            item.isSelected = true
          }else{
            item.isSelected = false
          }
        })
      },
      //选中地址
      selectAddress(){
        let isSelected = false
        let obj = { }
        this.addressList.forEach( ( item  ) => {
          if( item.isSelected ){  //有选中
            isSelected = true
            obj = item
          }
        })
        if( isSelected ){ //有选中地址
          obj.address = obj.provName + obj.cityName + obj.distName + obj.detail
          this.userAddress = obj
          this.addressChangeVisible = false
        } else {
          this.$message.error('请选择地址');
        }
      },
      createOrder(){
        if (!this.userAddress.name &&  this.checked1 ){
          this.$message.error('请完善发票寄送信息');
          return
        }
        const loading = this.$loading({
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        presalePayOrderReq({

          orderNo : this.obj.orderNo ,
          payChannel : this.radio1,
          invoiceType : this.checked1 ? 2 : 0 ,
          invoiceProperty : this.radio2 ,
          orderType :  this.obj.orderType ,
          deliveryId : this.obj.deliveryId ,
          invoiceProvName : this.userAddress.provName ,
          invoiceCityName : this.userAddress.cityName ,
          invoiceDistName : this.userAddress.distName ,
          invoiceName : this.userAddress.name ,
          invoicePhone : this.userAddress.phone ,
          invoiceDetail  : this.userAddress.detail ,
          isForward : this.userAddress.isForward ,
          tradeType : "NATIVE" ,
          verifyKey : this.obj.verifyKey ,
        }).then( res => {
          loading.close()
          if( res.data.status == 0 ){
            if( res.data.payChannel  == 1 ){ //微信支付
              this.payVisible = true
              this.payObj = {
                code_image : res.data.code_image ,
                company : res.data.company ,
                orderNo : res.data.orderNo ,
                payChannel : res.data.payChannel  ,
                price : res.data.price ,
                createTime : res.data.createTime ,
              }
              this.timer = setInterval(() => {
                // this.getTimeLeftFunc()
                this.payStatus()
              }, 1000);
            }else if(res.data.payChannel  == 2){
              this.payVisible = true
              this.payObj = {
                code_image : res.data.code_image ,
                company : res.data.company ,
                orderNo : res.data.orderNo ,
                payChannel : res.data.payChannel  ,
                price : res.data.price ,
                createTime : res.data.createTime ,
              }
              this.timer = setInterval(() => {
                // this.getTimeLeftFunc()
                this.payStatus()
              }, 1000);
            }else if( res.data.payChannel  == 4 ){ //交行支付
              let obj = { }
              obj.payPrice = this.payObj.price
              obj = JSON.stringify(obj)

              this.$router.replace({
                path: '/orderSubmitBank'  ,
                query: {
                  params : obj
                }
              })
            }



          }else{
            this.$message.error(res.data.statusDesc);
          }
        } )

      },
      //计算支付时间
      getTimeLeftFunc(){
        let createTime_zhuan = this.payObj.createTime;
        let createTime = createTime_zhuan.replace(/\-/g , '/');
        let createTime_s = new Date(createTime)
        let createTime_g = createTime_s.getTime()
        createTime_s.setTime(createTime_g + 1000 * 60 * this.moduleUser.minutes  )
        let timeLeft = this.getTimeLeft(createTime_s)
        this.timeLeft = timeLeft
      },
      // 计算倒计时方法
      getTimeLeft(datetimeTo) {
        // 计算目标与现在时间差（毫秒）
        let time1 = new Date(datetimeTo);
        let time2 = new Date().getTime();
        let mss = time1 - time2;
        if (mss <= 0) {
          return '已过期'
        }

        // 将时间差（毫秒）格式为：天时分秒
        // let days = parseInt(mss / (1000 * 60 * 60 * 24));
        // let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = parseInt((mss % (1000 * 60)) / 1000);
        // console.log(typeof (days.toString()) )
        return '请您在' + minutes.toString() + "分" + seconds.toString() + "秒以内支付，超时本订单将自动取消!"
      },
      payStatus(){
        payStatusReq({
          orderNo : this.payObj.orderNo
        }).then( res => {
          // console.log( res )
          if( res.data.payStatus == 1 ){
            clearInterval(this.timer);
            let obj = { }
            obj.createTime = this.payObj.createTime
            obj.payChannel = this.payObj.payChannel
            obj.price = this.payObj.price
            obj = JSON.stringify(obj)

            this.$router.replace({
              path: '/orderSubmit' ,
              query: {
                params : obj
              }
            })
          }

        })
      },
      payCancel(){
        clearInterval(this.timer);
        let obj = {}
        obj.createTime = this.payObj.createTime
        obj.payChannel = this.payObj.payChannel
        obj.price = this.payObj.price
        obj = JSON.stringify(obj)
        this.$router.replace({
          path: '/orderSubmitPayfail' ,
          query: {
            params : obj
          }
        })

      },
      //是否展示交行
      showOrNot() {
        var week = new Date().getDay();
        var hour = new Date().getHours();
        var minutes = new Date().getMinutes();
        if( this.moduleUser.activity_bcm_status == 'Y' ){
          this.showJiaohang = true
          return
        }
        if( this.moduleUser.bcm_status == 'N' ){
          this.showJiaohang = false
          return  false
        }
        if( week >= 1 && week  <=5 ){  //周一到周五
          if( hour >= 9 && hour < 18  ){  // 9 -18
            this.showJiaohang = true
          }else{
            this.showJiaohang = false
          }
        }else if( week == 0 || week == 6 ){  //周六周日
          if( hour >= 10 && hour < 18  ){  // 9 -18
            this.showJiaohang = true
          }else{
            this.showJiaohang = false
          }
        }
      }

    } ,
    created(){
      let obj =  JSON.parse( this.$route.query.params )
      obj.payPrice = obj.payPrice.toFixed(2)
      this.obj = obj

      this.verifyKey() //验证订单是否正确
      this.getDefaultUserAddress()
      this.showOrNot()
    } ,
    beforeDestroy() {
      //清除定时器
      clearInterval(this.timer);
    },
  };
</script>

<style lang="stylus" scoped>
.cont {
  width: 1200px;
  color: #000;
  margin: 0 auto;
  box-sizing: border-box;
}
  .radio_cont  >>> .el-radio__input{
    display : none
  }
  .el_radio_item{
    width:227px;
    text-align:center;
    height:50px;
    line-height:25px;
    background-color:#f9f9f9;
    color:#999999
  }
  .el_radio_item_wx {
    background-image: url("~@/assets/wxlogo.png");
    background-size: 70% ;
    background-repeat: no-repeat;
    background-position: center center
    padding 5px;
    box-sizing border-box
  }
  .el_radio_item_zfb {
    background-image: url("~@/assets/zfblogo.png");
    background-size: 50% ;
    background-repeat: no-repeat;
    background-position: center center
    padding 5px;
    box-sizing border-box
  }

  .pub_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
    .el-dialog {
        margin: 0 auto !important;
        height: 90%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            left: 0;
            top: 54px;
            bottom: 0;
            right: 0;
            padding: 0;
            z-index: 1;
            overflow: hidden;
            overflow-y: auto;
            .conpon_item{
              width 315px;
              height 110px;
              float left;
              border: 1px solid rgb(242, 242, 242);
              margin-bottom:20px
              margin-right:10px
              display:flex
              cursor:pointer
              position : relative
            }
              .conpon_item_arrow{
                position:absolute;right:0;bottom:0;width:47px;height:47px
              }
        }
    }
  }
  .addresslist_item{
    border:1px solid lightgray;
    padding:10px;
    margin-bottom:10px;
    font-size: 14px;
    color: #999999
  }
  .addresslist_item_active{
    border:1px solid #f90000;
  }
</style>
